import Travel from './Travel.vue';
import TravelInterval from './TravelInterval.vue';
import CardPlayBackInfo from './CardPlayBackInfo.vue';
import NoCompaniesDialog from './NoCompaniesDialog.vue';
import { FilterDialog } from './Filter';
import { FilterQuickAccess } from './Filter';
import { FilterByVehicleState } from './Filter';
import { AddFilter } from './AddFilter';
import { Filter, FilterConditions, VariableValue, Visualization } from '../../core/models';
import { OptionalVariableData } from '../../core/utils';

export { Travel, TravelInterval, CardPlayBackInfo, FilterDialog, AddFilter, NoCompaniesDialog, FilterQuickAccess, FilterByVehicleState };

export const initialFilter = (): Filter => ({
    id: '',
    name: '',
    conditions: [],
    visualizations: []
});

const compareVariable = (target: VariableValue, source: VariableValue): boolean =>
    !!(target.description && source.description && target.description === source.description);

const fromVariableValueToVariableKey = (variable: VariableValue, variablesMap: OptionalVariableData): string => {
    if (variablesMap) {
        const keys: string[] = Object.keys(variablesMap);
        return keys.filter(key => compareVariable(variable, variablesMap[key]))[0];
    } else {
        return '';
    }
};

const fromFilterConditionToCondition = (condition: FilterConditions, variablesMap: OptionalVariableData): any => {
    return {
        name: condition.name,
        variable: fromVariableValueToVariableKey(condition.variable, variablesMap),
        values: condition.values,
        typeFilter: condition.typeFilter
    };
};

const fromVisualizationToSaveVisualization = (
    visualization: Visualization,
    variablesMap: OptionalVariableData
): any => {
    return {
        name: visualization.name,
        variable: fromVariableValueToVariableKey(visualization.variable, variablesMap),
        min: visualization.min,
        max: visualization.max,
        painting_type: visualization.painting_type,
        tone_quantity: visualization.tone_quantity,
        working_width: visualization.working_width
    };
};

const fromFilterConditionsToConditions = (conditions: FilterConditions[], variablesMap: OptionalVariableData): any =>
    conditions.map(condition => fromFilterConditionToCondition(condition, variablesMap));

const fromVisualizationsToSaveVisualizations = (
    visualizations: Visualization[],
    variablesMap: OptionalVariableData
): any => visualizations.map(visualization => fromVisualizationToSaveVisualization(visualization, variablesMap));

export const fromFilterToSaveFilter = (filter: Filter, variablesMap: OptionalVariableData): any => {
    return {
        name: filter.name,
        conditions: fromFilterConditionsToConditions(filter.conditions, variablesMap),
        visualizations: fromVisualizationsToSaveVisualizations(filter.visualizations, variablesMap)
    };
};
